import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React, {useState} from 'react';
import useRouter from 'use-react-router';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import SearchBar from '../../../components/SearchBar';
import {User} from '../../../graphql/auth';
import {OPERATOR, WhereConstraints} from '../../../graphql/common.datatypes';
import {Group} from '../../../graphql/groups.datatypes';
import getUsers from '../../Users/getUsers.api';
import Results from './Results';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
  marginBottom: {
    marginBottom: theme.spacing(3)
  }
}));

// export interface FilterValues {
// }

export const GroupAdminListContent = (props: { group: Group, rowsPerPage?: number, addAdminUser?: (userId: number) => void, removeAdminUser?: (userId: number) => void }) => {
  const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage ? props.rowsPerPage : 20);
  const [page, setPage] = useState(1);

  const addDefaultContraints = (constraints: WhereConstraints) => {
    // if (props.groupId) {
    //   whereConstraints.AND = [
    //     {column: 'group_id', operator: OPERATOR.EQ, value: props.groupId},
    //   ]
    // }

    return {...constraints};
  }

  const [orderBy] = useState([{column: 'created_at', order: 'DESC'}]);
  const [where, setWhere] = useState(addDefaultContraints({}));
  const [selectedUser, setSelectedUser] = useState<User | undefined>();
  const usersData = getUsers(rowsPerPage, page, where, orderBy);

  const handleSearch = (value: string) => {
    let whereConstraints: WhereConstraints = {
      OR: [
        {column: 'first_name', operator: OPERATOR.LIKE, value: `%${value}%`},
        {column: 'last_name', operator: OPERATOR.LIKE, value: `%${value}%`},
        {column: 'email', operator: OPERATOR.LIKE, value: `%${value}%`},
      ]
    };

    whereConstraints = addDefaultContraints(whereConstraints)

    setWhere(whereConstraints);
  };

  return (
    <React.Fragment>
      <LoadingOverlay loading={usersData.loading}>

        <Results
          title="Existing Admins"
          className={classes.marginBottom}
          users={props.group.associatedUsers ? props.group.associatedUsers : []}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          action={props.removeAdminUser}
          actionTitle="Remove Admin"
        />

        <SearchBar className={classes.marginBottom} onSearch={handleSearch}/>

        {usersData.data && usersData.data.users && usersData.data.users.data && (
          <Results
            title="Add new Admin"
            users={usersData.data.users.data}
            paginatorInfo={usersData.data.users.paginatorInfo}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            action={props.addAdminUser}
            actionTitle="Add Admin"
            actionIgnoreIds={props.group.associatedUsers ? props.group.associatedUsers.map(user => user.id) : []}
          />
        )}
      </LoadingOverlay>
    </React.Fragment>
  );
};

const GroupAdminList = (props: { group: Group, rowsPerPage?: number, addAdminUser?: (userId: number) => void, removeAdminUser?: (userId: number) => void }) => {
  const {history} = useRouter();
  const classes = useStyles();
  const title = 'User LIst';
  const handleNewUser = () => {
    history.push('/users/new');
  };

  return (
    <Page className={classes.root} title={title}>
      <PageHeader section="users" title={title} action={{
        permission: 'user.create',
        label: 'Add User',
        onClick: handleNewUser,
      }}/>
      <GroupAdminListContent {...props}/>
    </Page>
  );
};

export default GroupAdminList;
